import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "row"
}
const _hoisted_3 = { class: "col-sm-12" }
const _hoisted_4 = { class: "alert alert-danger" }
const _hoisted_5 = {
  key: 1,
  class: "row"
}
const _hoisted_6 = { class: "col-sm-12" }
const _hoisted_7 = { class: "alert alert-danger" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = {
  for: "isAutoWithdrawalEnabled",
  class: "col-sm-6 col-form-label text-capitalize-first"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "col-sm-6 d-flex align-items-center" }
const _hoisted_13 = { class: "form-check form-switch" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 2,
  class: "row mt-2"
}
const _hoisted_16 = { class: "col-sm-12 d-flex justify-content-between align-items-center pb-0" }
const _hoisted_17 = {
  for: "autoWithdrawalMinSum",
  class: "col-form-label text-capitalize-first"
}
const _hoisted_18 = { class: "col-sm-12" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  key: 3,
  class: "row mt-2"
}
const _hoisted_21 = {
  for: "autoWithdrawalAddress",
  class: "col-sm-12 col-form-label text-capitalize-first"
}
const _hoisted_22 = { class: "col-sm-12" }
const _hoisted_23 = { class: "d-flex justify-content-between w-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInputWrapper = _resolveComponent("FormInputWrapper")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    title: _ctx.helper.trans('labels.auto_withdrawal_settings'),
    modelValue: _ctx.modal !== null,
    "footer-class": "",
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ($event === false && (_ctx.modal = null)))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_LoaderWrapper, { ref: "loader" }, {
        default: _withCtx(() => [
          (_ctx.requestDTO)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_ctx.account && !_ctx.account.withdrawalWhitelistsEnabled)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.helper.trans('labels.autoWithdrawalWarningText')), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.account && _ctx.account.isAutoTransferEnabled)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.helper.trans('labels.autoWithdrawalAutoTransferWarningText')), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("label", _hoisted_9, [
                    (_ctx.requestDTO.isAutoWithdrawalEnabled)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.helper.trans("labels.isAutoWithdrawalEnabled")), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.helper.trans("labels.isAutoWithdrawalDisabled")), 1))
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.requestDTO.isAutoWithdrawalEnabled) = $event)),
                        disabled: !_ctx.account?.withdrawalWhitelistsEnabled || _ctx.account?.isAutoTransferEnabled,
                        class: "form-check-input",
                        type: "checkbox",
                        id: "isAutoWithdrawalEnabled"
                      }, null, 8, _hoisted_14), [
                        [_vModelCheckbox, _ctx.requestDTO.isAutoWithdrawalEnabled]
                      ])
                    ])
                  ])
                ]),
                (_ctx.requestDTO.isAutoWithdrawalEnabled)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.helper.trans("labels.autoWithdrawalMinSum")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_FormInputWrapper, {
                          errors: _ctx.helper.getErrors('autoWithdrawal', 'autoWithdrawalMinSum')
                        }, {
                          default: _withCtx((parentProps) => [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.requestDTO.autoWithdrawalMinSum) = $event)),
                              disabled: !_ctx.account?.withdrawalWhitelistsEnabled || _ctx.account?.isAutoTransferEnabled,
                              "data-maska": "9 99#",
                              "data-maska-tokens": "9:[0-9]:repeated",
                              "data-maska-reversed": "",
                              class: _normalizeClass([parentProps.class, "form-control"]),
                              type: "text",
                              id: "autoWithdrawalMinSum"
                            }, null, 10, _hoisted_19), [
                              [_vModelText, _ctx.requestDTO.autoWithdrawalMinSum],
                              [_directive_maska]
                            ])
                          ]),
                          _: 1
                        }, 8, ["errors"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.requestDTO.isAutoWithdrawalEnabled)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.helper.trans("labels.address.usdt")), 1),
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_FormInputWrapper, {
                          errors: _ctx.helper.getErrors('autoWithdrawal','autoWithdrawalAddress')
                        }, {
                          default: _withCtx((parentProps) => [
                            _createVNode(_component_Multiselect, {
                              class: _normalizeClass([parentProps.class, "multiselect"]),
                              modelValue: _ctx.requestDTO.autoWithdrawalAddress,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.requestDTO.autoWithdrawalAddress) = $event)),
                              options: _ctx.whitelistAddresses,
                              "select-label": "Select",
                              "deselect-label": "",
                              disabled: !_ctx.account?.withdrawalWhitelistsEnabled || _ctx.account?.isAutoTransferEnabled,
                              placeholder: "",
                              "open-direction": "bottom",
                              id: "autoWithdrawalAddress",
                              multiple: false,
                              searchable: false,
                              "clear-on-select": false,
                              "close-on-select": true,
                              "show-no-results": false,
                              "hide-selected": false
                            }, null, 8, ["class", "modelValue", "options", "disabled"])
                          ]),
                          _: 1
                        }, 8, ["errors"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 512)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.modal = null)),
          class: "btn btn-outline-secondary btn-sm text-capitalize-first"
        }, _toDisplayString(_ctx.helper.trans('button.cancel')), 1),
        _createVNode(_component_LoaderWrapper, {
          ref: "saveLoader",
          zoom: 0.5
        }, {
          default: _withCtx(() => [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.save())),
              class: "btn btn-outline-primary btn-sm text-capitalize-first"
            }, _toDisplayString(_ctx.helper.trans('button.save')), 1)
          ]),
          _: 1
        }, 512)
      ])
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}